// extracted by mini-css-extract-plugin
export default {"input":"Input__input--slots-VuK4C"};